import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
interface LocationAddressIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
}
const LocationAddressIcon = forwardRef<SVGSVGElement, LocationAddressIconProps>(({
  fill = '#F0712A',
  ...props
}, ref) => <svg fill="none" viewBox="0 0 20 20" ref={ref} {...props}>
      <g clip-path="url(#a)">
        <path fill="#F0712A" d="M10 1.25a6.883 6.883 0 0 0-6.874 6.875c0 5.883 6.25 10.328 6.515 10.516a.648.648 0 0 0 .719 0c.266-.188 6.516-4.633 6.516-10.516A6.883 6.883 0 0 0 10 1.25Zm0 4.375a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>);
export default LocationAddressIcon;